/**
 * Add loading class to Gravity Form buttons when clicked
 */
var handleFormButton = function() {
    $(this).addClass('is-loading');
}